const links = [
  {
    title: 'Outdoor Camera',
    imageUrl:
      'https://cdn.shopify.com/s/files/1/0424/5923/4471/files/Frame_26.png?v=1726062885',
    productLink: '/products/outdoor-camera/',
  },
  {
    title: 'Doorbell Camera',
    imageUrl:
      'https://cdn.shopify.com/s/files/1/0424/5923/4471/files/Frame_27.png?v=1726062885',
    productLink: '/products/doorbell-camera-eufy/',
  },
  {
    title: 'Indoor Camera',
    imageUrl:
      'https://cdn.shopify.com/s/files/1/0424/5923/4471/files/Frame_29.png?v=1726062885',
    productLink: '/products/indoor-camera/',
  },
  {
    title: 'Window Sensor',
    imageUrl:
      'https://cdn.shopify.com/s/files/1/0424/5923/4471/files/Frame_2_1.png?v=1726062885',
    productLink: '/products/window-sensor/',
  },
  {
    title: 'Door Sensor',
    imageUrl:
      'https://cdn.shopify.com/s/files/1/0424/5923/4471/files/Frame_2_1.png?v=1726062885',
    productLink: '/products/door-sensor/',
  },
  {
    title: 'Motion Sensor',
    imageUrl:
      'https://cdn.shopify.com/s/files/1/0424/5923/4471/files/Frame_30.png?v=1726062885',
    productLink: '/products/motion-detector/',
  },
];

const QuickLinks = () => {
  return (
    <div className="block sm:hidden">
      <ul className="mb-0 flex items-start justify-between gap-cove-15 overflow-x-auto p-cove-15">
        {links.map((link) => {
          return (
            <li className="block" key={link.title}>
              <a
                href={link.productLink}
                className="flex min-w-cove-75 flex-col items-center justify-center gap-cove-10 text-center"
              >
                <img
                  className="rounded-full shadow-[0px_4px_8px_-2px_rgba(16,24,40,0.1)]"
                  src={link.imageUrl}
                  alt={link.title}
                />
                <span className="w-3/4 text-center text-[11px] leading-[14px] ">
                  {link.title}
                </span>
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default QuickLinks;
